import { AnyAction, Store } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';

let lazyStoreInstance: Store<RootState, AnyAction> | null = null;

export const setLazyRootStoreInstance = (storeInstance: Store<RootState, AnyAction>) => {
  lazyStoreInstance = storeInstance;
};

export const getLazyRootState = () => {
  if (!lazyStoreInstance) {
    throw new Error('Lazy root store not initialized');
  }

  return lazyStoreInstance.getState();
};

export const dispatchWithLazyRootStore = (action: AnyAction) => {
  if (!lazyStoreInstance) {
    throw new Error('Lazy root store not initialized');
  }

  return lazyStoreInstance.dispatch(action);
};
